var map = {
	"./issue1.json": "NwqK",
	"./issue10.json": "KbOO",
	"./issue11.json": "ZqpF",
	"./issue12.json": "rPGC",
	"./issue13.json": "nuFe",
	"./issue2.json": "cV1M",
	"./issue3.json": "jGUI",
	"./issue4.json": "165R",
	"./issue5.json": "6ET8",
	"./issue6.json": "5kWj",
	"./issue7.json": "u7yF",
	"./issue8.json": "7W3I",
	"./issue9.json": "+/c/"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ME4a";